import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import styled from '@emotion/styled'
import * as React from 'react'

import useCanonical from '~/hooks/useCanonical'
import useAtmosphere from '../../hooks/useAtmosphere'
import useForm from '../../hooks/useForm'
import useMutationProps from '../../hooks/useMutationProps'
import ResetPasswordMutation from '../../mutations/ResetPasswordMutation'
import Legitity from '../../validation/Legitity'
import AuthenticationDialog from '../AuthenticationDialog'
import DialogTitle from '../DialogTitle'
import ErrorAlert from '../ErrorAlert/ErrorAlert'
import PasswordInputField from '../PasswordInputField'
import PrimaryButton from '../PrimaryButton'
import TeamInvitationWrapper from '../TeamInvitationWrapper'



const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column'
})

const P = styled('p')({
  fontSize: 14,
  lineHeight: 1.5,
  margin: '16px 0',
  textAlign: 'center'
})

const Container = styled('div')({
  margin: '0 auto',
  maxWidth: 240,
  width: '100%'
})

const SubmitButton = styled(PrimaryButton)({
  marginTop: 16
})

const validatePassword = (password) => {
  return new Legitity(password)
    .required('Please enter a password')
    .min(6, '6 character minimum')
    .max(1000, `That's a book, not a password`)
}

const SetNewPassword = (props) => {
  const {history, match} = props
  const {params} = match
  const {token} = params
  const atmosphere = useAtmosphere()
  useCanonical('reset-password')
  const {onCompleted, onError, error, submitting, submitMutation} = useMutationProps()
  const {fields, onChange, setDirtyField, validateField} = useForm({
    password: {
      getDefault: () => '',
      validate: validatePassword
    }
  })
  const handleBlur = (e) => {
    const {name} = e.target
    if (name === 'password') {
      setDirtyField(name)
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (submitting) return
    setDirtyField()
    const {password: passwordRes} = validateField()
    if (passwordRes.error) return
    const {value: newPassword} = passwordRes
    submitMutation()
    ResetPasswordMutation(atmosphere, {newPassword, token}, {onError, onCompleted, history})
  }
  return (
    _jsx(TeamInvitationWrapper, { children: 
      _jsxs(AuthenticationDialog, { children: [
        _jsx(DialogTitle, { children: 'Reset Password'})
        , _jsxs(Container, { children: [
          _jsx(P, { children: 'Type your new password below'})
          , error && _jsx(ErrorAlert, { message: error.message,} )
          , _jsxs(Form, { onSubmit: onSubmit, children: [
            _jsx(PasswordInputField, {
              ...fields.password,
              autoFocus: true,
              onChange: onChange,
              onBlur: handleBlur,}
            )
            , _jsx(SubmitButton, { size: "medium", waiting: submitting, children: 
              'Reset Password'
            })
          ]})
        ]})
      ]})
    })
  )
}

export default SetNewPassword
